<style src="./CreditCard.scss" lang="scss" scoped></style>
<template>
  <div class="credit-card">
    <span class="title">CRÉDITO</span>
    <div class="credit">
      <span class="amount-paid">R$ {{ currencyBR(info.amountPaid) }}</span>
      <span class="totalminutes">{{ convertMinutesToHour(info.totalMinutes) }}</span>
    </div>

    <span
      class="settled-status settled-paid"
      v-show="info.settled && info.amountPaid !== 0"
      >PAGO</span
    >
    <span
      class="settled-status settled-exception"
      v-show="info.amountPaid === 0"
      >EXCEÇÃO</span
    >
    <span class="settled-status settled-notpaid" v-show="!info.settled"
      >NÃO PAGO</span
    >

    <span class="employee">
      <i class="fa fa-user"></i>
      {{ info.employee }}
    </span>
    <span class="employee" v-show="info.settled">
      <i class="fa fa-check"></i>
      {{ info.settledEmployee }}
    </span>
    <span class="employee" v-show="info.paymentType">
      <i class="fa fa-money"></i>
      {{ formatPaymentType(info.paymentType) }}
    </span>
    <span class="employee" v-show="info.paymentDate">
      {{ dateBR(info.paymentDate) }} - {{ timeBR(info.paymentDate) }}
    </span>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'CreditCard',
  props: {
    info: {
      default: {},
    },
  },
  methods: {
    currencyBR(v) {
      return (Number(v) / 100).toFixed(2).toString().replace('.', ',');
    },
    convertMinutesToHour(v) {
      return v >= 60 ? `${v / 60}h` : `${v}m`;
    },
    dateBR(v) {
      return moment(new Date(v)).format('DD/MM/YYYY');
    },
    timeBR(v) {
      return moment(new Date(v)).format('HH:mm:ss');
    },
    formatPaymentType(v) {
      switch (v) {
        case 'cash':
          return 'Dinheiro';
        case 'credit':
          return 'Crédito';
        case 'debit':
          return 'Débito';
        case 'wallet':
          return 'Carteira';
      }
    },
  },
};
</script>